import React, { Component } from 'react'
import CacheKeys from '../../../../cache/CacheKeys.js'
import CacheManager from '../../../../cache/CacheManager.js'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils.js'
import SystemGeneratedPropertyListUI from './SystemGeneratedPropertyListUI.js'

class SystemGeneratedPropertyListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  render() {
    return (
      <SystemGeneratedPropertyListUI
        context={this.props.context}
        errorList={this.props.errorList}
        propertyList={this.props.propertyList}
        category={this.props.category}
        categoryLabel={this.props.categoryLabel}
        loan={this.props.loan}
        // events
        onRefreshClick={this.props.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }
}

export default SystemGeneratedPropertyListSF
